export default {
  addedSubject(state) {
    return state.addedSubject;
  },
};
